import React from 'react';
import { TagBase } from '@milanote/roma';

type TagElementProps = {
    name: string;
    color: string;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
    onClick?: () => void;
};

const TagElement: React.FC<TagElementProps> = ({ name, color, size, onClick }) => {
    return (
        <div className="TagElement" onClick={onClick}>
            <TagBase size={size} color={color} className="cursor-pointer max-w-full">
                {name}
            </TagBase>
        </div>
    );
};

export default TagElement;
